import { createMuiTheme, Theme } from "@material-ui/core/styles";

export const theme: Theme = createMuiTheme({
  palette: {
    primary: {
      light: "#6573c3",
      main: "#3f51b5",
      dark: "#2c387e"
    },
    secondary: {
      light: "#f73378",
      main: "#f50057",
      dark: "#ab003c"
    }
  }
});
